import { ApplicationConfig, LOCALE_ID } from '@angular/core';
import { provideRouter, withComponentInputBinding, withInMemoryScrolling } from '@angular/router';

import { routes } from './app.routes';
import { provideIcons } from '@ng-icons/core';
import { faBookmark, faCircleUser, faFlag, faClock, faStar } from '@ng-icons/font-awesome/regular'
import { faSolidBookmark, faSolidBookOpen, faSolidList, faSolidSpinner, faSolidCircleRight, faSolidDumbbell, faSolidGraduationCap, faSolidClock, faSolidInfinity, faSolidGem, faSolidClipboardQuestion, faSolidArrowRight, faSolidTriangleExclamation, faSolidStar, faSolidLock, faSolidXmark, faSolidBuildingColumns } from '@ng-icons/font-awesome/solid'
import { faBrandGoogle, faBrandMicrosoft } from '@ng-icons/font-awesome/brands';

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: LOCALE_ID, useValue: 'de' },
    provideRouter(
      routes,
      withComponentInputBinding(),
      withInMemoryScrolling({
        anchorScrolling: 'enabled',
        scrollPositionRestoration: 'enabled'
      })  
    ),
    provideIcons({ faSolidBookmark, faBookmark, faSolidBookOpen, faSolidList, faCircleUser, faSolidSpinner, faSolidCircleRight, faBrandGoogle, faBrandMicrosoft, faSolidDumbbell, faSolidGraduationCap, faSolidClock, faSolidInfinity, faSolidGem, faSolidClipboardQuestion, faFlag, faClock, faSolidArrowRight, faSolidTriangleExclamation, faSolidStar, faStar, faSolidLock, faSolidXmark, faSolidBuildingColumns })
  ]
};
